import { useState, useCallback } from 'react';

export const useAlert = () => {
  const [alert, setAlert] = useState(null);

  const showAlert = useCallback((options) => {
    setAlert({
      isOpen: true,
      ...options
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlert(null);
  }, []);

  const showConfirm = useCallback((title, message, options = {}) => {
    return new Promise((resolve) => {
      const hasThirdButton = !!options.thirdButtonText;

      setAlert({
        isOpen: true,
        title,
        message,
        type: 'confirm',
        showCancel: true,
        confirmText: options.confirmText || 'Yes',
        cancelText: options.cancelText || 'No',
        thirdButtonText: options.thirdButtonText,
        onConfirm: () => {
          hideAlert();
          resolve(true);
        },
        onCancel: hasThirdButton ? () => {
          hideAlert();
          resolve(false);
        } : undefined,
        onClose: () => {
          hideAlert();
          resolve(hasThirdButton ? null : false);
        }
      });
    });
  }, [hideAlert]);

  const showError = useCallback((title, message) => {
    showAlert({
      title,
      message,
      type: 'error',
      confirmText: 'OK',
      onClose: hideAlert
    });
  }, [showAlert, hideAlert]);

  const showWarning = useCallback((title, message) => {
    showAlert({
      title,
      message,
      type: 'warning',
      confirmText: 'OK',
      onClose: hideAlert
    });
  }, [showAlert, hideAlert]);

  const showSuccess = useCallback((title, message) => {
    showAlert({
      title,
      message,
      type: 'success',
      confirmText: 'OK',
      onClose: hideAlert
    });
  }, [showAlert, hideAlert]);

  const showInfo = useCallback((title, message) => {
    showAlert({
      title,
      message,
      type: 'info',
      confirmText: 'OK',
      onClose: hideAlert
    });
  }, [showAlert, hideAlert]);

  const showShareLink = useCallback((title, message, shareUrl, onCreateVisualCard) => {
    showAlert({
      title,
      message,
      type: 'success',
      confirmText: 'Done',
      shareUrl: shareUrl,
      onCreateVisualCard: onCreateVisualCard,
      onClose: hideAlert
    });
  }, [showAlert, hideAlert]);

  return {
    alert,
    showAlert,
    hideAlert,
    showConfirm,
    showError,
    showWarning,
    showSuccess,
    showInfo,
    showShareLink
  };
};